import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  meetingtypes: []
}

const mutations = {  
  SET_MEETINGTYPES (state, payload) {
    state.meetingtypes = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  meetingtypesList: (context, data) => {
    let query = '?'    
    for (let f in data) {       
      if (Array.isArray(data[f])) {
        for (let element of data[f]) {                 
          query += `&${f}[]=${element}`
        }
      } else {          
        query += `&${f}=${data[f]}`
      }
    }
    return Vue.http.get(`${env.API}/api/meeting-type${query}`)    
      .then((response) => {        
        context.commit('SET_MEETINGTYPES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  meetingtypesByIds: (context, data) => {
    let query = '?'
    if (Array.isArray(data)) {
      for (let element of data) {                 
        query += `&ids[]=${element}`
      }
    }
    return Vue.http.get(`${env.API}/api/meeting-type/by-ids${query}`)    
      .then((response) => {        
        context.commit('SET_MEETINGTYPES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getMeetingtypes: (state) => state.meetingtypes
}

export const meetingtype = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/meetingtype.js